import axios from 'axios';
/**
 * 
 * This upload adapter is built based on the SimpleUploadAdapter provided by CKEditor.
 * 
 */

/**
 * 
 * @param {*} editor 
 */
function StrapiUploadAdapter(editor) {
	// console.log('Try create', editor);
	editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
		const options = editor.config.get( 'strapiUploadAdapter' );
		return new StrapiAdapter(loader, options,editor);
	};
}

export default StrapiUploadAdapter;

/**
 * Strapi upload adapter.
 *
 * @private
 * @implements module:upload/filerepository~UploadAdapter
 */
class StrapiAdapter {
	/**
	 * Creates a new adapter instance.
	 *
	 * @param {module:upload/filerepository~FileLoader} loader
	 * @param {module:upload/adapters/simpleuploadadapter~SimpleUploadConfig} options
	 */
	constructor( loader, options, editor ) {
		/**
		 * FileLoader instance to use during the upload.
		 *
		 * @member {module:upload/filerepository~FileLoader} #loader
		 */
		this.loader = loader;

		/**
		 * The configuration of the adapter.
		 *
		 * @member {module:upload/adapters/simpleuploadadapter~SimpleUploadConfig} #options
		 */
		this.options = options;
		this.editor = editor;
	}

	/**
	 * Starts the upload process.
	 *
	 * @see module:upload/filerepository~UploadAdapter#upload
	 * @returns {Promise}
	 */
	upload() {
		return this.loader.file
			.then( file => new Promise( ( resolve, reject ) => {
				this._initRequest();
				this._initListeners( resolve, reject, file );
				this._sendRequest( file );
			} ) );
	}

	/**
	 * Aborts the upload process.
	 *
	 * @see module:upload/filerepository~UploadAdapter#abort
	 * @returns {Promise}
	 */
	abort() {
		if ( this.xhr ) {
			this.xhr.abort();
		}
	}

	/**
	 * Initializes the `XMLHttpRequest` object using the URL specified as
	 * {@link module:upload/adapters/simpleuploadadapter~SimpleUploadConfig#uploadUrl `simpleUpload.uploadUrl`} in the editor's
	 * configuration.
	 *
	 * @private
	 */
	_initRequest() {
		const xhr = this.xhr = new XMLHttpRequest();

		xhr.open( 'POST', this.options.uploadUrl, true );
		xhr.responseType = 'json';
	}

	/**
	 * Initializes XMLHttpRequest listeners
	 *
	 * @private
	 * @param {Function} resolve Callback function to be called when the request is successful.
	 * @param {Function} reject Callback function to be called when the request cannot be completed.
	 * @param {File} file Native File object.
	 */
	_initListeners( resolve, reject, file ) {
		const xhr = this.xhr;
		const loader = this.loader;
		const genericErrorText = `Couldn't upload file: ${ file.name }.`;

		xhr.addEventListener( 'error', () => reject( genericErrorText ) );
		xhr.addEventListener( 'abort', () => reject() );
		xhr.addEventListener( 'load', () => {
			// return;
			const response = xhr.response;
			if ( !response || response.error ) {
				return reject( response && response.error && response.error.message ? response.error.message : genericErrorText );
			}

			let returnUrl = null;
			if(response && response.url) {
				let url = response.url;
 				// if(this.options !== undefined && this.options.absUrl !== undefined && this.options.absUrl !== null) {
				// 	let absUrl = this.options.absUrl; 
				// 	// If the user has given a absUrl ending in a /, let's remove it.
				// 	absUrl = absUrl.replace(/\/$/, "");
				// 	url = absUrl + url;
				// }
				returnUrl = { default: url };
				axios({
					method: 'post',
					url: '/92know/admin/content',
					data:{type:this.options.type,content: this.editor.getData()}
				  }).then(response => {

				});
			}
			resolve(returnUrl);
		} );

		// Upload progress when it is supported.
		/* istanbul ignore else */
		if ( xhr.upload ) {
			xhr.upload.addEventListener( 'progress', evt => {
				if ( evt.lengthComputable ) {
					loader.uploadTotal = evt.total;
					loader.uploaded = evt.loaded;
				}
			} );
		}
	}

	/**
	 * Prepares the data and sends the request.
	 *
	 * @private
	 * @param {File} file File instance to be uploaded.
	 */
	_sendRequest( file ) {
		// Set headers if specified.
		const headers = this.options.headers || {};

		for ( const headerName of Object.keys( headers ) ) {
			this.xhr.setRequestHeader( headerName, headers[ headerName ] );
		}

		// Prepare the form data.
		const data = new FormData();

		data.append( 'files', file );

		// Send the request.
		this.xhr.send( data );
	}
}
